import React, { FC, MouseEvent as TMouseEvent } from 'react';
import { SButton } from './styled';

export type ButtonProps = {
  fullWidth?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  isIcon?: boolean;
  onClick?: (e: TMouseEvent<HTMLButtonElement, MouseEvent>) => void;
  size: 'small' | 'medium';
  variant: 'primary' | 'secondary' | 'tertiary' | 'tooltip';
};

export const Button: FC<ButtonProps> = ({
  children,
  fullWidth,
  isActive,
  isDisabled,
  isIcon,
  onClick,
  size,
  variant
}) => (
  <SButton
    type="button"
    fullWidth={fullWidth}
    isIcon={isIcon}
    disabled={isDisabled}
    data-active={isActive}
    variant={variant}
    size={size}
    onClick={onClick}
  >
    {children}
  </SButton>
);
